import { render, staticRenderFns } from "./FloatingSearch.vue?vue&type=template&id=5358eeb8&scoped=true"
import script from "./FloatingSearch.vue?vue&type=script&lang=js"
export * from "./FloatingSearch.vue?vue&type=script&lang=js"
import style0 from "./FloatingSearch.vue?vue&type=style&index=0&id=5358eeb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5358eeb8",
  null
  
)

export default component.exports